import axios from "@/utils/axios.js";

/**
 * 提交身份变更
 * @param {object} params  当前用户的状态，其余置空（旧需求）
 * status: 当前用户的状态,
 * frozenFlag: "",
 * partnerId: "",
 * permitFile: ""
 */
export async function updateCategory(params) {
  return axios.post("/agentLogin/updateCategory", params);
}

/**
 * 核验华发业主身份
 * @param {object} params
 * cusName: 用户姓名,
 * idNumber: 用户id
 */
export async function checkSale(params) {
  return axios.post("/salesCustomer/check/exist", params);
}

/**
 * 校验华发员工身份
 * agentIdNumber: 用户id
 */
export async function checkEmp(agentIdNumber) {
  return axios.get(`/emp/findByIdcard/${agentIdNumber}`);
}

/**
 * 校验拓客身份
 * @param {object} params
 * tel: 用户手机号
 */
export async function checkTeam(params) {
  console.log("checkTeam params", params);
  return axios.post("/developCustomer/search", params);
}
